import { Outlet } from 'react-router-dom';
import BottomNavigation from '@/domains/mobile-web/components/BottomNavigation/BottomNavigation';

const MainScreen = () => {
  return (
    <div className="relative flex min-h-screen flex-col">
      <main className="flex-1 pb-16">
        <Outlet />
      </main>

      <BottomNavigation />
    </div>
  );
};

export default MainScreen;
